module.exports = __webpack_public_path__ + "static/media/radar.588607c8.svg";